module.exports = __webpack_public_path__ + "img/Stat_xp.ba99f5a2.png";